import { memo } from "react";
import styles from "./styles.js";

import Videocam from "@material-ui/icons/Videocam";
import Switch from "@material-ui/core/Switch";
import { useTranslation } from "react-i18next";

const VideoSettings = memo(({ hasVideo, onVideoChange, className }) => {
  const {t} = useTranslation();
  const classes = styles();
  return (
    <div className={className}>
      <div className={classes.circle}>
        <Videocam style={{ fontSize: 24 }} />
      </div>
      <p className={classes.text}>{t('yourCamera')}</p>
      <Switch
        color="primary"
        checked={hasVideo}
        onChange={onVideoChange}
        name="VideoToggle"
      />
    </div>
  );
});

export default VideoSettings;
